import React, { useMemo } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

export interface TraineeStatusFilterProps {
  value?: string;
  onChange?: (status: string | undefined) => void;
}

const TraineeStatusFilter: React.FC<TraineeStatusFilterProps> = ({
  value,
  onChange
}) => {
  const options = [
    { value: 'compliant', label: 'Compliant' },
    { value: 'in-progress', label: 'In-Progress' },
    { value: 'non-compliant', label: 'Non-Compliant' }
  ];

  const selected = useMemo(() => {
    return value ? options.find(option => option.value === value) : undefined;
  }, [value]);

  return (
    <Autocomplete
      options={options}
      value={selected || null}
      getOptionLabel={option => option.label}
      onChange={(_, value) => {
        onChange?.(value?.value);
      }}
      renderInput={params => (
        <TextField {...params} fullWidth variant='outlined' />
      )}
    />
  );
};

export default TraineeStatusFilter;
